var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "login" } },
    [
      _c("h2", [_vm._v("Login")]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loginStatus == "pending",
              expression: "loginStatus == 'pending'"
            }
          ],
          attrs: {
            novalidate: "true",
            "label-width": "8em",
            "label-position": _vm.formLabelPosition,
            size: _vm.formSize
          }
        },
        [
          _vm.accountExists
            ? _c("el-alert", {
                attrs: {
                  title: "You must log in with your email for this account.",
                  type: "error"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "fb-login-container" }, [
            _c("div", {
              staticClass: "fb-login-button",
              attrs: {
                "data-width": "",
                "data-size": "large",
                "data-button-type": "continue_with",
                "data-auto-logout-link": "false",
                "data-use-continue-as": "true",
                onlogin: "window.fbLoginCallback('" + this.getRedirect() + "')"
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "divider" }),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Email address", error: _vm.errors.email } },
            [
              _c("el-input", {
                attrs: { placeholder: "Enter your email" },
                model: {
                  value: _vm.email,
                  callback: function($$v) {
                    _vm.email = $$v
                  },
                  expression: "email"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Password", error: _vm.errors.password } },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "Enter your password",
                  "show-password": ""
                },
                model: {
                  value: _vm.password,
                  callback: function($$v) {
                    _vm.password = $$v
                  },
                  expression: "password"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.login } },
                [_vm._v("Login")]
              ),
              _vm._v(" "),
              _vm.$route.name != "password"
                ? _c(
                    "router-link",
                    {
                      staticClass: "forgot-password",
                      attrs: { to: { name: "password" } }
                    },
                    [_vm._v("I forgot my password")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }